export const COMPANY = {
  name: "Fragua Global Limited",
  tagline: "Your Passage to the World",
  owners: ["Kingsley Antwi", "Aaron Appiagyei"],
  whatsapp: "0208636267",
  whatsappIntl: "233208636267",
  whatsapp2: "+1 (803) 933-4887",
  whatsapp2Intl: "18039334887",
  momo: "0208636267",
  banks: [
    { name: "Guaranty Trust Bank (GTBank)", account: "1216001073110" },
    { name: "ABSA Bank", account: "0281043919" },
  ],
};

export const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/7ae72017-57f2-4017-90df-bc78beebdd67/images/ffda0d17f924ebc5d9b4c52ff65cf2e03b78d1e0d80085af34cae6f1ac647afd.jpeg";

export const SERVICES = [
  {
    key: "visa",
    title: "Visa & Document Processing",
    desc: "Expert guidance on tourist, student, work and business visas. We handle applications end-to-end with meticulous attention to detail.",
    image: "https://images.unsplash.com/photo-1655722725332-9925c96dd627?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwYXNzcG9ydCUyMHZpc2ElMjBzdGFtcHMlMjBkb2N1bWVudHN8ZW58MHx8fHwxNzkwNjQxNzUzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "tour",
    title: "Flights, Hotels & Tour Packages",
    desc: "Curated luxury itineraries, seamless flight and hotel bookings, and bespoke tour packages to the world's most coveted destinations.",
    image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxoYXBweSUyMHRvdXJpc3RzJTIwbHV4dXJ5fGVufDB8fHx8MTc5MDY0MTcwN3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1581553673739-c4906b5d0de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxwYXNzcG9ydCUyMHZpc2ElMjBzdGFtcHMlMjBkb2N1bWVudHN8ZW58MHx8fHwxNzkwNjQxNzUzfDA&ixlib=rb-4.1.0&q=85", label: "Approved Visa Sample", tall: true },
  { url: "https://images.unsplash.com/photo-1564507592333-c60657eea523?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHx3b3JsZCUyMGxhbmRtYXJrcyUyMHRyYXZlbCUyMGRlc3RpbmF0aW9uc3xlbnwwfHx8fDE3OTA2NDE3NTN8MA&ixlib=rb-4.1.0&q=85", label: "India" },
  { url: "https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGJlYWNoJTIwcmVzb3J0JTIwdmFjYXRpb258ZW58MHx8fHwxNzkwNjQxNzUzfDA&ixlib=rb-4.1.0&q=85", label: "Maldives" },
  { url: "https://images.unsplash.com/photo-1500153556700-4c8db53996c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx3b3JsZCUyMGxhbmRtYXJrcyUyMHRyYXZlbCUyMGRlc3RpbmF0aW9uc3xlbnwwfHx8fDE3OTA2NDE3NTN8MA&ixlib=rb-4.1.0&q=85", label: "Paris", tall: true },
  { url: "https://images.unsplash.com/photo-1454496406107-dc34337da8d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxwYXNzcG9ydCUyMHZpc2ElMjBzdGFtcHMlMjBkb2N1bWVudHN8ZW58MHx8fHwxNzkwNjQxNzUzfDA&ixlib=rb-4.1.0&q=85", label: "Travel Documents" },
  { url: "https://images.unsplash.com/photo-1586500036065-bdaeac7a4feb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMGJlYWNoJTIwcmVzb3J0JTIwdmFjYXRpb258ZW58MHx8fHwxNzkwNjQxNzUzfDA&ixlib=rb-4.1.0&q=85", label: "Zanzibar" },
];

export const OWNERS = [
  {
    name: "Kingsley Antwi",
    role: "Co-Founder & CEO",
    bio: "A renowned businessman with years of experience across educational consulting, the automobile industry, mining, and oil & gas.",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_nomad-portal-11/artifacts/eh06x7l5_1771556619127.png",
  },
  {
    name: "Aaron Appiagyei",
    role: "Co-Founder & COO",
    bio: "A businessman, prophet and lawyer with years of experience in educational consultancy, the automobile industry, and finance.",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_nomad-portal-11/artifacts/i9a8pmnh_IMG-20260623-WA0005.jpg",
  },
];

export const STATUS_META = {
  submitted: { label: "Submitted", color: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
  under_review: { label: "Under Review", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  processing: { label: "Processing", color: "bg-purple-500/15 text-purple-300 border-purple-500/30" },
  approved: { label: "Approved", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  completed: { label: "Completed", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  rejected: { label: "Rejected", color: "bg-red-500/15 text-red-300 border-red-500/30" },
  pending: { label: "Pending", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  verified: { label: "Verified", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
};

export const STATUS_STEPS = ["submitted", "under_review", "processing", "approved", "completed"];

export const SERVICE_FEES = { visa: 40000, tour: 40000 };
export const formatGHS = (n) => `GHS ${Number(n).toLocaleString()}`;
